import {useMemo} from 'react';

import {getLinePlotSettingsWithDefaults} from '../../WorkspaceDrawer/Settings/runLinePlots/utils/getLinePlotSettings';
import {RunsLinePlotConfig} from '../types';

export const useRunsLinePlotSettings = (config: RunsLinePlotConfig) => {
  return useMemo(() => getLinePlotSettingsWithDefaults(config), [config]);
};
